import { useCallback } from "react";

import { useActivationSet } from "../../hooks/useActivationSet";
import { useActivationSetFavicons } from "../../hooks/useActivationSetFavicons";
import { AlertsFeed } from "../AlertsFeed";
import { Virtualized } from "../Virtualized";

import { AdsAlertModal } from "./components/ads-alert-modal/AdsAlertModal";
import { AdsAlertCard } from "./components/AdsAlertCard";
import { useAdsAlerts } from "./useAdsAlerts";

export const AdsAlertsFeed = () => {
    const { data, isLoading: isAlertsLoading } = useAdsAlerts();
    const { activationSet } = useActivationSet();
    const { favicons, isLoading: isFaviconsLoading } = useActivationSetFavicons();

    const getItemKey = useCallback(
        (index: number) => {
            const group = data[index];
            return `${group.domain}-${group.groupType}-${index}`;
        },
        [data],
    );

    return (
        <>
            <AlertsFeed
                isLoading={isAlertsLoading || isFaviconsLoading || !activationSet}
                isEmpty={!data.length}
            >
                {activationSet && (
                    <Virtualized
                        count={data.length}
                        getItemKey={getItemKey}
                        renderItem={(index) => (
                            <AdsAlertCard
                                group={data[index]}
                                country={activationSet.country}
                                favicon={favicons?.[data[index].domain] ?? ""}
                                groupIndex={index}
                            />
                        )}
                    />
                )}
            </AlertsFeed>
            <AdsAlertModal
                favicons={favicons}
                groups={data}
            />
        </>
    );
};
